import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { GroupingBrandForms, GroupingFormBrandType } from './groupingTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.grouping.font, {
  base: FONT_FIELDS.base,
  h4: FONT_FIELDS.h4,
})

const TypographyBase: GroupingFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.base}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.grouping.tags.text')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TypographyH4: GroupingFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.h4}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.grouping.tags.result')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const GroupingTypography: GroupingFormBrandType = ({ device, edited, setForm, element }) => {
  const values = useElementFontValues('grouping', device, element?.font)
  const styles = useElementFontCss('grouping', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.base}
        font='base'
        onClick={setForm}
        styles={styles.base}
        values={values.base}
      >
        {t('elements.grouping.tags.text')}
      </BrandButtonFont>

      <BrandButtonFont
        edited={edited.font?.h4}
        font='h4'
        onClick={setForm}
        styles={styles.h4}
        values={values.h4}
      >
        {t('elements.grouping.tags.result')}
      </BrandButtonFont>
    </Padding>
  )
}

const FORM_MAP: GroupingBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: GroupingTypography,
  base: TypographyBase,
  h4: TypographyH4,
}

export default FORM_MAP
